import React from "react";
import styles from "./CheckboxWithLabel.module.css";

interface CheckboxWithLabelProps {
    id: string;
    label: string;
    description?: string;
    checked: boolean;
    onChange?: (checked: boolean) => void;
}

const CheckboxWithLabel: React.FC<CheckboxWithLabelProps> = ({
    id,
    label,
    description,
    checked,
    onChange,
}) => {
    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isCheckedFlag = e.target.checked;
        if (onChange) {
            onChange(isCheckedFlag);
        }
    };

    return (
        <div className={styles.checkboxContainer}>
            <label className={styles.checkboxLabel} htmlFor={id}>
                <input
                    id={id}
                    type="checkbox"
                    checked={checked}
                    onChange={handleCheckboxChange}
                    className={styles.checkboxInput}
                />
                <span className={styles.customCheckbox} />
                <div className={styles.labelAndDescription}>
                    <div className={styles.labelText}>{label}</div>
                    {description && <div className={styles.checkboxDescription}>{description}</div>}
                </div>
            </label>
        </div>
    );
};

export default CheckboxWithLabel;
